__turbopack_context__.v({
  "accordionBody": "CommercialSecurityPage-module__faOh_a__accordionBody",
  "accordionButton": "CommercialSecurityPage-module__faOh_a__accordionButton",
  "accordionButtonOpen": "CommercialSecurityPage-module__faOh_a__accordionButtonOpen",
  "accordionItem": "CommercialSecurityPage-module__faOh_a__accordionItem",
  "accordionListContent": "CommercialSecurityPage-module__faOh_a__accordionListContent",
  "accordionListCta": "CommercialSecurityPage-module__faOh_a__accordionListCta",
  "accordionListGrid": "CommercialSecurityPage-module__faOh_a__accordionListGrid",
  "accordionListImage": "CommercialSecurityPage-module__faOh_a__accordionListImage",
  "accordionListImageWrap": "CommercialSecurityPage-module__faOh_a__accordionListImageWrap",
  "accordionWrapper": "CommercialSecurityPage-module__faOh_a__accordionWrapper",
  "body": "CommercialSecurityPage-module__faOh_a__body",
  "callout": "CommercialSecurityPage-module__faOh_a__callout",
  "calloutHeading": "CommercialSecurityPage-module__faOh_a__calloutHeading",
  "capabilityItem": "CommercialSecurityPage-module__faOh_a__capabilityItem",
  "capabilityList": "CommercialSecurityPage-module__faOh_a__capabilityList",
  "capabilityStrip": "CommercialSecurityPage-module__faOh_a__capabilityStrip",
  "cols2": "CommercialSecurityPage-module__faOh_a__cols2",
  "cols3": "CommercialSecurityPage-module__faOh_a__cols3",
  "cols4": "CommercialSecurityPage-module__faOh_a__cols4",
  "column": "CommercialSecurityPage-module__faOh_a__column",
  "columnRow": "CommercialSecurityPage-module__faOh_a__columnRow",
  "ctaPanel": "CommercialSecurityPage-module__faOh_a__ctaPanel",
  "ctaPanelCopy": "CommercialSecurityPage-module__faOh_a__ctaPanelCopy",
  "ctaPanelHeading": "CommercialSecurityPage-module__faOh_a__ctaPanelHeading",
  "ctaPanelLink": "CommercialSecurityPage-module__faOh_a__ctaPanelLink",
  "featureCard": "CommercialSecurityPage-module__faOh_a__featureCard",
  "featureRow": "CommercialSecurityPage-module__faOh_a__featureRow",
  "galleryCard": "CommercialSecurityPage-module__faOh_a__galleryCard",
  "galleryContent": "CommercialSecurityPage-module__faOh_a__galleryContent",
  "galleryGrid": "CommercialSecurityPage-module__faOh_a__galleryGrid",
  "galleryImage": "CommercialSecurityPage-module__faOh_a__galleryImage",
  "galleryImageWrap": "CommercialSecurityPage-module__faOh_a__galleryImageWrap",
  "galleryPrice": "CommercialSecurityPage-module__faOh_a__galleryPrice",
  "galleryTagline": "CommercialSecurityPage-module__faOh_a__galleryTagline",
  "galleryTitle": "CommercialSecurityPage-module__faOh_a__galleryTitle",
  "h3": "CommercialSecurityPage-module__faOh_a__h3",
  "h4": "CommercialSecurityPage-module__faOh_a__h4",
  "hero": "CommercialSecurityPage-module__faOh_a__hero",
  "heroCtaButton": "CommercialSecurityPage-module__faOh_a__heroCtaButton",
  "heroCtaLink": "CommercialSecurityPage-module__faOh_a__heroCtaLink",
  "heroCtaRow": "CommercialSecurityPage-module__faOh_a__heroCtaRow",
  "heroCtaSolid": "CommercialSecurityPage-module__faOh_a__heroCtaSolid",
  "heroEyebrow": "CommercialSecurityPage-module__faOh_a__heroEyebrow",
  "heroFormAnchor": "CommercialSecurityPage-module__faOh_a__heroFormAnchor",
  "heroFormEmbed": "CommercialSecurityPage-module__faOh_a__heroFormEmbed",
  "heroInner": "CommercialSecurityPage-module__faOh_a__heroInner",
  "heroIntro": "CommercialSecurityPage-module__faOh_a__heroIntro",
  "heroJumbotron": "CommercialSecurityPage-module__faOh_a__heroJumbotron",
  "heroSplit": "CommercialSecurityPage-module__faOh_a__heroSplit",
  "heroSplitCopy": "CommercialSecurityPage-module__faOh_a__heroSplitCopy",
  "heroSplitForm": "CommercialSecurityPage-module__faOh_a__heroSplitForm",
  "heroSplitGrid": "CommercialSecurityPage-module__faOh_a__heroSplitGrid",
  "heroSplitImage": "CommercialSecurityPage-module__faOh_a__heroSplitImage",
  "heroSplitImageWrap": "CommercialSecurityPage-module__faOh_a__heroSplitImageWrap",
  "heroSplitSecondaryImage": "CommercialSecurityPage-module__faOh_a__heroSplitSecondaryImage",
  "heroSupportingHeading": "CommercialSecurityPage-module__faOh_a__heroSupportingHeading",
  "heroTitle": "CommercialSecurityPage-module__faOh_a__heroTitle",
  "heroTitleAccent": "CommercialSecurityPage-module__faOh_a__heroTitleAccent",
  "hotboxCard": "CommercialSecurityPage-module__faOh_a__hotboxCard",
  "hotboxCta": "CommercialSecurityPage-module__faOh_a__hotboxCta",
  "hotboxHeading": "CommercialSecurityPage-module__faOh_a__hotboxHeading",
  "hotboxRow": "CommercialSecurityPage-module__faOh_a__hotboxRow",
  "hubspotFormEmbed": "CommercialSecurityPage-module__faOh_a__hubspotFormEmbed",
  "image": "CommercialSecurityPage-module__faOh_a__image",
  "industryCard": "CommercialSecurityPage-module__faOh_a__industryCard",
  "industryCardImage": "CommercialSecurityPage-module__faOh_a__industryCardImage",
  "industryCardInner": "CommercialSecurityPage-module__faOh_a__industryCardInner",
  "industryCardLabel": "CommercialSecurityPage-module__faOh_a__industryCardLabel",
  "industryGrid": "CommercialSecurityPage-module__faOh_a__industryGrid",
  "link": "CommercialSecurityPage-module__faOh_a__link",
  "page": "CommercialSecurityPage-module__faOh_a__page",
  "paragraph": "CommercialSecurityPage-module__faOh_a__paragraph",
  "priorityCard": "CommercialSecurityPage-module__faOh_a__priorityCard",
  "priorityGrid": "CommercialSecurityPage-module__faOh_a__priorityGrid",
  "reviewRatingText": "CommercialSecurityPage-module__faOh_a__reviewRatingText",
  "reviewStar": "CommercialSecurityPage-module__faOh_a__reviewStar",
  "reviewStarLink": "CommercialSecurityPage-module__faOh_a__reviewStarLink",
  "reviewStarsSummary": "CommercialSecurityPage-module__faOh_a__reviewStarsSummary",
  "reviewSummary": "CommercialSecurityPage-module__faOh_a__reviewSummary",
  "section": "CommercialSecurityPage-module__faOh_a__section",
  "sidebarAside": "CommercialSecurityPage-module__faOh_a__sidebarAside",
  "sidebarBox": "CommercialSecurityPage-module__faOh_a__sidebarBox",
  "sidebarGrid": "CommercialSecurityPage-module__faOh_a__sidebarGrid",
  "sidebarHeading": "CommercialSecurityPage-module__faOh_a__sidebarHeading",
  "sidebarList": "CommercialSecurityPage-module__faOh_a__sidebarList",
  "sidebarMain": "CommercialSecurityPage-module__faOh_a__sidebarMain",
  "useCaseItem": "CommercialSecurityPage-module__faOh_a__useCaseItem",
});
